import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => {
  const tooltipColor = theme.palette.grey[800];
  return {
    arrow: {
      color: tooltipColor,
    },
    tooltip: {
      backgroundColor: tooltipColor,
      ...theme.typography.body2,
      fontFamily: 'sans-serif',
    },
  };
});

function Tooltip(props) {
  const classes = useStyles();

  return <MuiTooltip arrow classes={classes} {...props} />;
}

export default Tooltip;
